import { render, staticRenderFns } from "./BaseInputLanding.vue?vue&type=template&id=56db546a&scoped=true"
import script from "./BaseInputLanding.vue?vue&type=script&lang=ts"
export * from "./BaseInputLanding.vue?vue&type=script&lang=ts"
import style0 from "./BaseInputLanding.vue?vue&type=style&index=0&id=56db546a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56db546a",
  null
  
)

export default component.exports